import { Dropdown } from "@carbon/react";
import React, { useContext, useEffect, useState } from "react";
import NumberField from "../components/inputs/NumberField";
import TextField from "../components/inputs/TextField";
import AuthContext from "../store/authContext";
import { HEX_INPUT_TRANSLATIONS } from "../translations/util";

interface IProps {
  label: string;
  placeholder?: string;
  max: number;
  min: number;
  disabled?: boolean;
  onChange: (value?: number) => void;
  value?: number;
  invalid?: boolean;
  invalidText?: string;
  tooltipText?: string;
  required?: boolean;
}

const hexToDecimal = (hex: string) => parseInt(hex, 16);

export const decimalToHex = (num: number) => {
  return `0x${num.toString(16)}`;
};

const HexInput = ({
  label,
  placeholder,
  max,
  min,
  disabled = false,
  onChange,
  value,
  invalid = false,
  invalidText,
  tooltipText,
  required,
}: IProps) => {
  const { hexMode } = useContext(AuthContext);
  const items = [HEX_INPUT_TRANSLATIONS.HEX, HEX_INPUT_TRANSLATIONS.DEC];
  const [currentItem, setCurrentItem] = useState(hexMode ? items[0] : items[1]);
  const [hexValue, setHexValue] = useState("");

  useEffect(() => {
    if (value || value === 0) {
      setHexValue(decimalToHex(value));
    } else {
      setHexValue("");
    }
  }, [value]);

  return (
    <div className="hexdec-block">
      <div className="input-wrapper">
        <Dropdown
          className="input-dropdown"
          items={items}
          disabled={disabled}
          selectedItem={currentItem}
          onChange={({ selectedItem }: { selectedItem: string }) =>
            setCurrentItem(selectedItem)
          }
          data-cy={`${label.replaceAll(" ", "")}-dropdown`}
        />
        <div className="input-field">
          {currentItem === "HEX" ? (
            <TextField
              labelText={label}
              onChange={(t) => onChange(hexToDecimal(t))}
              value={hexValue}
              placeholder={placeholder || label}
              required={required}
              tooltipText={tooltipText}
              invalid={invalid}
              invalidText={invalidText}
              disabled={disabled}
            />
          ) : (
            <NumberField
              label={label}
              placeholder={placeholder || label}
              value={value}
              max={max}
              min={min}
              tooltipText={tooltipText}
              required={required}
              disabled={disabled}
              invalid={invalid}
              invalidText={invalidText}
              onChange={onChange}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HexInput;
